/**
 * Generates a random number for the client to uniquely identify it in /auth
 */
function getFingerprint(): number {
  let fingerPrintId: number = Math.random() * 4294967;
  fingerPrintId = Math.max(fingerPrintId, 0);
  fingerPrintId = Math.min(fingerPrintId, 4294967295);
  fingerPrintId += -2147483648;
  return fingerPrintId;
}

export { getFingerprint };
